module.exports = __webpack_public_path__ + "img/travel-agency.83fbb38e.png";